var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarsSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 20000,
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 20000",
    style: {
      enableBackground: "new 0 0 1280 20000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 187,
    height: 20000
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    className: "st0",
    width: 187,
    height: 20000
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    className: "st0",
    width: 187,
    height: 20000
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 656,
    className: "st0",
    width: 187,
    height: 20000
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    className: "st0",
    width: 187,
    height: 20000
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1094,
    className: "st0",
    width: 187,
    height: 20000
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsSix);
export default __webpack_public_path__ + "static/media/bars-six.a644fd1369e87dfb10f98175cab64f68.svg";
export { ForwardRef as ReactComponent };